import {
  LANGUAGE,
  HTML_TAG_REGEX,
  HTML_TAG_REGEX_SRT_PROJECT,
} from '@src/constants';
import { WHITESPACE_REGEX } from '@src/constants/voiceCloning';

const removeVietnameseTones = (str, language = 'en') => {
  if (language === LANGUAGE.VN) return str;

  let text = str;
  text = text.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  text = text.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  text = text.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  text = text.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  text = text.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  text = text.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  text = text.replace(/đ/g, 'd');
  text = text.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  text = text.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  text = text.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  text = text.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  text = text.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  text = text.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  text = text.replace(/Đ/g, 'D');
  // Some system encode vietnamese combining accent as individual utf-8 characters
  text = text.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  text = text.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  text = text.replace(/ + /g, ' ');
  text = text.trim();
  return text;
};

const upperCaseFirstLetter = (str = '') => {
  const convertedToLowerCase = str.toLowerCase();
  return (
    convertedToLowerCase.charAt(0).toUpperCase() + convertedToLowerCase.slice(1)
  );
};

const removeHtmlTags = (text) => {
  const cleanText = text.replace(HTML_TAG_REGEX, ' ').toLowerCase().trim();
  return cleanText;
};

const removeHtmlTagsSrtProject = (text) => {
  const cleanText = text.replace(HTML_TAG_REGEX_SRT_PROJECT, ' ');
  return cleanText;
};

const removeSpecialCharacters = (str) => {
  const specialCharacters = ['\\u200B'];

  const specialCharactersRegex = new RegExp(specialCharacters.join('|'), 'g');
  return str.replace(specialCharactersRegex, '');
};

const countSyllables = (text) => {
  const words = text.split(WHITESPACE_REGEX);
  return words.length;
};

const removeWhiteSpace = (str) => str.replace(/ /g, '');

const unsignText = (str) => {
  if (!str || typeof str !== 'string') return '';

  return str
    .normalize('NFC') // Normalize composed characters
    .normalize('NFD') // Separate accents from letters
    .replace(/[\u0300-\u036f]/g, '') // Remove accent characters
    .replace(/đ/g, 'd') // đ → d
    .replace(/Đ/g, 'D') // Đ → D
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '') // Remove spaces
    .replace(/[^a-z0-9]/g, ''); // Remove special characters, keep a-z, 0-9
};

const getOrdinal = (num, lang = 'en') => {
  if (lang === 'vi') return String(num);

  const j = num % 10;
  const k = num % 100;

  if (k >= 11 && k <= 13) return `${num}th`;

  switch (j) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
};

export {
  removeVietnameseTones,
  upperCaseFirstLetter,
  removeHtmlTags,
  removeSpecialCharacters,
  countSyllables,
  unsignText,
  removeWhiteSpace,
  getOrdinal,
  removeHtmlTagsSrtProject,
};
